import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';

export interface ITwoFactorStatus {
    enabled: boolean;
    enrolledAt: string | null;
    backupCodesRemaining: number;
    backupCodesDisabled: boolean;
}

export interface ITwoFactorSetup {
    challengeId: string;
    qrDataUri: string;
    secret: string;
}

export const TwoFactorService = {
    getStatus: async (): Promise<ITwoFactorStatus> => {
        const response = await axios.get(ENDPOINTS.TWO_FACTOR.STATUS, { headers: AuthService.getAuthHeader() });
        return response.data;
    },

    setup: async (): Promise<ITwoFactorSetup> => {
        const response = await axios.post(ENDPOINTS.TWO_FACTOR.SETUP, {}, { headers: AuthService.getAuthHeader() });
        return response.data;
    },

    enable: async (challengeId: string, code: string): Promise<string[]> => {
        const response = await axios.post(ENDPOINTS.TWO_FACTOR.ENABLE, { challengeId, code }, { headers: AuthService.getAuthHeader() });
        return response.data;
    },

    disable: async (code: string): Promise<void> => {
        await axios.post(ENDPOINTS.TWO_FACTOR.DISABLE, { code }, { headers: AuthService.getAuthHeader() });
    },

    regenerateBackupCodes: async (code: string): Promise<string[]> => {
        const response = await axios.post(ENDPOINTS.TWO_FACTOR.REGENERATE_BACKUP_CODES, { code }, { headers: AuthService.getAuthHeader() });
        return response.data;
    },
};
